import React from 'react';
import classNames from 'classnames';
import { observer } from 'mobx-react-lite';

import Button from 'src/components/ui/button';
import IconButton from 'src/components/ui/icon-button';
import { ReactComponent as CartIcon } from 'src/assets/icons/cart.svg';
import { ReactComponent as CloseIcon } from 'src/assets/icons/close.svg';

import cartStore from 'src/stores/cart-store';

import useSluggedNavigate from 'src/hooks/use-slugged-navigate';
import { AppRoute, GoogleAnalyticsButton, GoogleAnalyticsPage, LOCALES } from 'src/constants';
import { formatMoney, getGoogleAnalyticsEvent } from 'src/utils';
import type { TotalCostProps } from './total-cost.props';

import './total-cost.scss';

const TotalCost = observer(({ className, onCloseCart }: TotalCostProps) => {
  const navigate = useSluggedNavigate();

  const { isCartEmpty, isOpenCart, totalSum, openCart } = cartStore;

  const handleCartToggle = () => {
    if (isOpenCart) {
      onCloseCart();
    } else {
      openCart();
    }
  };

  return (
    <div className={classNames('total-cost', className, isCartEmpty && 'total-cost_empty-cart')}>
      <IconButton
        className="total-cost__cart"
        ariaLabel={isOpenCart ? LOCALES.CLOSE_CART : LOCALES.OPEN_CART}
        icon={
          isOpenCart ? (
            <CloseIcon className="total-cost__icon" />
          ) : (
            <CartIcon className="total-cost__icon total-cost__icon_cart" />
          )
        }
        onClick={handleCartToggle}
        size="normal"
      />
      <button className="total-cost__info" onClick={openCart}>
        {' '}
        <span className="total-cost__info-label">{LOCALES.ORDER_TOTAL}:</span>
        <span className="total-cost__info-value">{formatMoney(totalSum)}</span>
      </button>
      <Button
        analyticsEvent={getGoogleAnalyticsEvent(
          GoogleAnalyticsPage.SERVICES,
          GoogleAnalyticsButton.CHECKOUT
        )}
        className="total-cost__button"
        isDisabled={isCartEmpty}
        isTabletSizeGrowth
        label={LOCALES.CHECKOUT}
        onClick={() => navigate(AppRoute.CHECKOUT_PAGE_ROUTE)}
        size="normal"
        theme="filled"
      />
    </div>
  );
});

export default TotalCost;
